import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { IBulkDistributionResponse, IBulkEditChanges, IBulkEditResponse, IBulkManagePair, IBulkManageResponse, IBulkTransitionResponse, ICreateLicenseNoteRequest, IDistributionInstruction, ILicenseLink, ILicenseNote, ILicenseUsage, ILicenseV2, ILicenseV2Request, IOrgOption, TransitionAction } from "../../common/models/license.interface";

export const LicenseV2Actions = createActionGroup({
    source: 'LicenseV2',
    events: {
        loadLicenses: props<{ includeChildren?: boolean }>(),
        loadLicensesSuccess: props<{ licenses: ILicenseV2[] }>(),
        loadLicensesFailure: props<{ error: Error }>(),

        getLicenseById: props<{ licenseId: string }>(),
        getLicenseByIdSuccess: props<{ license: ILicenseV2 }>(),
        getLicenseByIdFailure: props<{ error: Error }>(),

        addLicense: props<{ license: ILicenseV2Request }>(),
        addLicenseSuccess: props<{ licenses: ILicenseV2[] }>(),
        addLicenseFailure: props<{ error: Error }>(),

        updateLicense: props<{ license: ILicenseV2Request }>(),
        updateLicenseSuccess: props<{ license: ILicenseV2 }>(),
        updateLicenseFailure: props<{ error: Error }>(),

        deleteLicenses: props<{ ids: string[] }>(),
        deleteLicensesSuccess: props<{ licenses: ILicenseV2[] }>(),
        deleteLicensesFailure: props<{ error: Error }>(),

        bulkTransition: props<{ action: TransitionAction; ids: string[]; prices?: Record<string, number> }>(),
        bulkTransitionSuccess: props<{ action: TransitionAction; response: IBulkTransitionResponse }>(),
        bulkTransitionFailure: props<{ error: Error }>(),

        bulkEditLicenses: props<{ ids: string[]; changes: IBulkEditChanges }>(),
        bulkEditLicensesSuccess: props<{ response: IBulkEditResponse }>(),
        bulkEditLicensesFailure: props<{ error: Error }>(),
        resetBulkEdit: emptyProps(),

        loadLicenseUsage: props<{ licenseId: string }>(),
        loadLicenseUsageSuccess: props<{ licenseId: string; usage: ILicenseUsage[] }>(),
        loadLicenseUsageFailure: props<{ licenseId: string; error: Error }>(),
        clearLicenseUsage: props<{ licenseId: string }>(),

        distributeLicenses: props<{ instructions: IDistributionInstruction[] }>(),
        distributeLicensesSuccess: props<{ response: IBulkDistributionResponse }>(),
        distributeLicensesFailure: props<{ error: Error }>(),

        loadLicenseLinks: props<{ licenseIds: string[] }>(),
        loadLicenseLinksSuccess: props<{ linksByLicense: { licenseId: string; links: ILicenseLink[] }[] }>(),
        loadLicenseLinksFailure: props<{ error: Error }>(),

        loadGlobalLinks: props<{ licenseIds: string[] }>(),
        loadGlobalLinksSuccess: props<{ linksByLicense: { licenseId: string; links: ILicenseLink[] }[] }>(),
        loadGlobalLinksFailure: props<{ error: Error }>(),

        loadLinksOverview: props<{ licenseIds: string[] }>(),
        loadLinksOverviewSuccess: props<{ linksByLicense: { licenseId: string; links: ILicenseLink[] }[] }>(),
        loadLinksOverviewFailure: props<{ error: Error }>(),

        bulkManageLinks: props<{ pairs: IBulkManagePair[] }>(),
        bulkManageLinksSuccess: props<{ response: IBulkManageResponse }>(),
        bulkManageLinksFailure: props<{ error: Error }>(),

        clearLinkManagement: emptyProps(),

        loadLinkEntityData: props<{ licenseId: string }>(),
        loadLinkEntityDataSuccess: props<{ currentlyLinkedOrgId: string | null; orgOptions: IOrgOption[] }>(),
        loadLinkEntityDataFailure: props<{ error: Error }>(),
        clearLinkEntityData: emptyProps(),

        unlinkFromOrganisation: props<{ pairs: IBulkManagePair[] }>(),
        unlinkFromOrganisationSuccess: props<{ response: IBulkManageResponse }>(),
        unlinkFromOrganisationFailure: props<{ error: Error }>(),

        loadChildOrganisations: emptyProps(),
        loadChildOrganisationsSuccess: props<{ childOrgs: IOrgOption[] }>(),
        loadChildOrganisationsFailure: props<{ error: Error }>(),
        clearChildOrganisations: emptyProps(),

        clearLicenses: emptyProps(),

        loadLicenseNotes: props<{ licenseId: string }>(),
        loadLicenseNotesSuccess: props<{ licenseId: string; notes: ILicenseNote[] }>(),
        loadLicenseNotesFailure: props<{ error: Error }>(),
        clearLicenseNotes: emptyProps(),

        createLicenseNote: props<{ request: ICreateLicenseNoteRequest }>(),
        createLicenseNoteSuccess: props<{ note: ILicenseNote }>(),
        createLicenseNoteFailure: props<{ error: Error }>(),
        resetNoteCreate: emptyProps(),

        deleteLicenseNote: props<{ noteId: string }>(),
        deleteLicenseNoteSuccess: props<{ noteId: string }>(),
        deleteLicenseNoteFailure: props<{ error: Error }>(),
    }
});
